<app-ariane-nav [label]="arianeLabel" [icon]="arianeIcon" [arianeList]="arianeList"></app-ariane-nav>
<mat-divider class="my-3"></mat-divider>
<div class="container px-5 mt-5">
  <div class="stepper-container row">
    <h3 class="text-secondary mb-0">
      <b>Etape {{ currentStepIndex + 1 }} sur 4</b>
    </h3>
    <h2 class="mb-0">
      <b>Formulaire : {{ currentTitle }}</b>
    </h2>
    <mat-horizontal-stepper
      labelPosition="bottom"
      ngClass="{{ 'last-edited-step-' + stepper.selectedIndex }}"
      [linear]="true"
      #stepper
      (selectionChange)="onStepChange($event)"
      >
      <mat-step [stepControl]="step1">
        @if (nextTitle) {
          <h4 class="next-step text-secondary mb-5"><b>Etape suivante :</b> {{ nextTitle }}</h4>
        }
        <h4>Les champs annotés d'un astérique * sont obligatoires.</h4>
        <app-informations-generales-form
          [form]="step1"
          (posteDetailsChange)="updatePosteDetails($event)"
        ></app-informations-generales-form>
      </mat-step>
      <mat-step [stepControl]="step2">
        @if (nextTitle) {
          <h4 class="next-step text-secondary mb-5"><b>Etape suivante :</b> {{ nextTitle }}</h4>
        }
        <h4>Les champs annotés d'un astérique * sont obligatoires.</h4>
        <app-caracteristiques-generales-form
          [qualificationForm]="step2"
          [agentsList]="detenteurPosteList"
          [detenteurPosteReadOnly]="detenteurPosteReadOnly"
          [typeRecrutement]="step1.get('typeRecrutement')?.value"
          [selectedPosteDetails]="selectedPosteDetails"
          [isVacataireType]="isVacataireType()"
        ></app-caracteristiques-generales-form>
      </mat-step>
      <mat-step [stepControl]="step3">
        @if (nextTitle) {
          <h4 class="next-step text-secondary mb-5"><b>Etape suivante :</b> {{ nextTitle }}</h4>
        }
        <h4>Les champs annotés d'un astérique * sont obligatoires.</h4>
        <app-motivation-demande-form
          (filesSelected)="handleFileSelected($event)"
          [motivationRequestForm]="step3"
        ></app-motivation-demande-form>
      </mat-step>
      <mat-step [stepControl]="step4">
        <h4>Les champs annotés d'un astérique * sont obligatoires</h4>
        <app-destinataires-demande-form
          [destinataireform]="step4"
          [service]="selectedService"
          [direction]="selectedDirection"
          (formSubmit)="onSubmitForm()"
        ></app-destinataires-demande-form>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
